import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'
import { vMaska } from 'maska'
import App from '@internal/App.vue'
import router from '@internal/router'
import { i18n } from '@internal/i18n'
import { checkForLatestVersion } from '@shared/utils/helpers'
import { CometChat } from '@cometchat-pro/chat'
import posthogPlugin from '@internal/plugins/posthog'
import sentryPlugin from '@internal/plugins/sentry'

const appID = import.meta.env.COMET_CHAT_APP_ID
const region = import.meta.env.COMET_CHAT_REGION
const appSetting = new CometChat.AppSettingsBuilder().subscribePresenceForAllUsers().setRegion(region).build()

CometChat.init(appID, appSetting)

// SVG icons
import 'virtual:svg-icons-register'

// Global styles
import '@shared/scss/index.scss'

// App styles
import '@internal/scss/index.scss'

const app = createApp(App)
app.use(posthogPlugin)
app.provide('posthog', app.config.globalProperties.$posthog)
app.use(sentryPlugin)
app.use(createPinia())
app.use(i18n)
app.use(router)
app.directive('maska', vMaska)
app.mount('#internal-dashboard')

router.afterEach((to, from, failure) => {
  if (!failure) {
    nextTick(() => {
      app.config.globalProperties.$posthog.capture('$pageview', { path: to.fullPath })
    })
  }
})

if (import.meta.env.TEMBO_IS_DEVELOPMENT !== 'true') {
  setInterval(checkForLatestVersion, 60000)
}
